import React, { FC } from "react";
import { Box, Checkbox, CheckboxProps, FormControlLabel } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";

export interface ConsentCheckboxProps extends CheckboxProps{
  renderContent: React.ReactNode;
}
export const ConsentCheckbox: FC<ConsentCheckboxProps> = (props) => {
  const {renderContent} = props
  return (<Box display="flex" flexDirection="column"  alignItems="baseline" gap={2}>
    <FormControlLabel
      control={
        <Checkbox
          {...props}
          sx={{ 
            color: "var(--primary-text)",
            "&.Mui-checked": { color: "var(--Schemes-Primary)" } }}
        />
      }
      label={renderContent}
    />
  </Box>)
}